import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { BillingPage } from '@/routes/billing/page'

export const Billing = () => (
  <PageErrorBoundary>
    <BillingPage />
  </PageErrorBoundary>
)
